import { getProxyUrl } from '.'
import { addOptionsAuth } from './auth'

export async function getEncimerasFrontales(): Promise<Record<string, string>> {
  const url = getProxyUrl('api/acabados/getencimerasfrontales')

  const params: RequestInit = addOptionsAuth({
    method: 'GET',
    mode: 'cors',
    headers: {
      'Accept-Language': 'ES',
      'Content-Type': 'application/json',
    },
  })

  try {
    const response = await fetch(url, params)
    if (response.ok) {
      const data = await response.json()
      return data as Record<string, string>
    } else {
      console.error('Error en getEncimerasFrontales:', response.status, response.statusText)
      return {}
    }
  } catch (error) {
    console.error('Error en getEncimerasFrontales:', error)
    return {}
  }
}
